import { ONE_PAGE_STORE_TRACKER_TYPE } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

export const onTrackCartCodeCreditPointApply = async (payload) => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: ONE_PAGE_STORE_TRACKER_TYPE.CartCodeCreditPointApply,
    data: {
      scope: 'one_page_store',
      event_category: 'Cart',
      ...payload,
    },
  });
};
